var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#smallMobile)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78571 21C7.44286 21 7.14286 20.8773 6.88571 20.6318C6.62857 20.3864 6.5 20.1 6.5 19.7727V4.22727C6.5 3.9 6.62857 3.61364 6.88571 3.36818C7.14286 3.12273 7.44286 3 7.78571 3H17.2143C17.5571 3 17.8571 3.12273 18.1143 3.36818C18.3714 3.61364 18.5 3.9 18.5 4.22727V19.7727C18.5 20.1 18.3714 20.3864 18.1143 20.6318C17.8571 20.8773 17.5571 21 17.2143 21H7.78571ZM12.5 19.4659C12.6857 19.4659 12.8393 19.408 12.9607 19.292C13.0821 19.1761 13.1429 19.0295 13.1429 18.8523C13.1429 18.675 13.0821 18.5284 12.9607 18.4125C12.8393 18.2966 12.6857 18.2386 12.5 18.2386C12.3143 18.2386 12.1607 18.2966 12.0393 18.4125C11.9179 18.5284 11.8571 18.675 11.8571 18.8523C11.8571 19.0295 11.9179 19.1761 12.0393 19.292C12.1607 19.408 12.3143 19.4659 12.5 19.4659ZM7.78571 16.7045H17.2143V6.06818H7.78571V16.7045Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "smallMobile"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMobile);
export default __webpack_public_path__ + "static/media/smallMobile.e86a25b32ae6aaa42afcd6d4cb4fe3b9.svg";
export { ForwardRef as ReactComponent };